import {
  SubscriptionStates,
  User,
  UserLinkStatuses,
  UserRoles,
  UserStates
} from 'services/api/types';

/**
 * the data in this user list is for various tests and branches
 *
 * Subscription
 * 1. subscription.state
 *
 * Employee
 * 1. linked_status
 */
export const mockUserList: User[] = [
  {
    id: 1,
    name: 'Steve Jobs',
    first_name: 'Steve',
    last_name: 'Jobs',
    company: 'Apple',
    company_id: 1,
    role: UserRoles.Manager,
    email: 'steve.jobs@apple.com',
    state: UserStates.Active,
    linked_status: UserLinkStatuses.Linked,
    created_at: '2022-04-12T01:42:09Z',
    updated_at: '2022-04-12T01:42:09Z',
    department: {
      id: 100,
      name: 'default',
      total_users: 10
    },
    employee_code: '123',
    cost_center: {
      id: 1,
      name: 'MapleTree Costcentre',
      state: 'Inactive',
      total_users: 23
    },
    expense_codes: [
      {
        id: 1,
        name: 'Monster',
        state: 'Inactive',
        comment: 'Robot',
        total_users: 100
      },
      {
        id: 2,
        name: 'Alien',
        state: 'Active',
        comment: 'Kaiju',
        total_users: 53
      }
    ],
    customer_code: {
      b2b: '',
      b2c: ''
    },
    mobile_country_code: '+65',
    mobile_number: '1234-5678',
    subscription: {
      plan_code: 'sg-corporate-plan',
      duration: 1,
      code: 'sub-2GcUfdBeVDHwKzoCHjs4vDjSaDU',
      source: 'b2b',
      state: SubscriptionStates.enabled,
      start_date: '2022-10-25T08:44:30Z',
      end_date: '2022-11-26T08:44:30Z',
      next_billing_date: '2022-11-25T08:44:30Z',
      last_billing_date: '2022-10-25T08:44:30Z',
      amount: 4.99,
      is_auto_renewal: true
    },
    require_account_linking: true,
    is_eligible_for_all_expense_codes: false,
    account_linked: true,
    pending_orders: 0,
    cancelled_orders: 10,
    delivered_orders: 20,
    in_progress_orders: 1
  },
  {
    id: 2,
    name: 'John Dow',
    first_name: 'John',
    last_name: 'Dow',
    company: 'Foodpanda',
    company_id: 2,
    role: UserRoles.User,
    email: 'john.dow@foodpanda.com',
    state: UserStates.Invited,
    linked_status: UserLinkStatuses.Unlinked,
    created_at: '2022-04-12T01:42:09Z',
    updated_at: '2022-04-12T01:42:09Z',
    department: {
      id: 101,
      name: 'default2',
      total_users: 10
    },
    employee_code: '123',
    cost_center: {
      id: 1,
      name: 'MapleTree Costcentre',
      state: 'Inactive',
      total_users: 23
    },
    expense_codes: [],
    customer_code: {
      b2b: '',
      b2c: ''
    },
    mobile_country_code: '',
    mobile_number: '',
    subscription: {
      plan_code: 'sg-corporate-plan',
      duration: 1,
      code: 'sub-2GcUfdBeVDHwKzoCHjs4vDjSaDU',
      source: 'b2b',
      state: SubscriptionStates.cancelled,
      start_date: '2022-10-25T08:44:30Z',
      end_date: '2022-11-27T08:44:30Z',
      next_billing_date: '2022-11-25T08:44:30Z',
      last_billing_date: '2022-10-25T08:44:30Z',
      amount: 4.99,
      is_auto_renewal: true
    },
    require_account_linking: true,
    is_eligible_for_all_expense_codes: false,
    account_linked: false,
    account_linking_url: 'www.foodpanda.sg',
    pending_orders: 0,
    cancelled_orders: 10,
    delivered_orders: 20,
    in_progress_orders: 1
  },
  {
    id: 3,
    name: 'Frank Sinatra',
    first_name: 'Frank',
    last_name: 'Sinatra',
    company: 'Apple',
    company_id: 1,
    role: UserRoles.User,
    email: 'frank.sinatra@apple.com',
    state: UserStates.Invited,
    linked_status: UserLinkStatuses.NotRequired,
    created_at: '2022-04-12T01:42:09Z',
    updated_at: '2022-04-12T01:42:09Z',
    department: {
      id: 103,
      name: 'default3',
      total_users: 10
    },
    employee_code: '123',
    cost_center: {
      id: 1,
      name: 'MapleTree Costcentre',
      state: 'Inactive',
      total_users: 23
    },
    expense_codes: [],
    customer_code: {
      b2b: '',
      b2c: ''
    },
    mobile_country_code: '',
    mobile_number: '',
    subscription: {
      plan_code: 'sg-corporate-plan',
      duration: 1,
      code: 'sub-2GcUfdBeVDHwKzoCHjs4vDjSaDU',
      source: 'b2b',
      state: SubscriptionStates.subscription_requested,
      start_date: '2022-10-25T08:44:30Z',
      end_date: '2022-11-28T08:44:30Z',
      next_billing_date: '2022-11-25T08:44:30Z',
      last_billing_date: '2022-10-25T08:44:30Z',
      amount: 4.99,
      is_auto_renewal: true
    },
    require_account_linking: true,
    is_eligible_for_all_expense_codes: false,
    account_linked: true,
    pending_orders: 0,
    cancelled_orders: 10,
    delivered_orders: 20,
    in_progress_orders: 1
  },
  {
    id: 4,
    name: 'Frank, Sinatra',
    first_name: 'Frank',
    last_name: 'Sinatra',
    company: 'Apple',
    company_id: 1,
    role: UserRoles.User,
    email: 'frank.sinatra@apple.com',
    state: UserStates.Deleted,
    linked_status: UserLinkStatuses.Unlinked,
    created_at: '2022-04-12T01:42:09Z',
    updated_at: '2022-04-12T01:42:09Z',
    department: {
      id: 100,
      name: 'default',
      total_users: 10
    },
    employee_code: '123',
    cost_center: {
      id: 1,
      name: 'MapleTree Costcentre',
      state: 'Inactive',
      total_users: 23
    },
    expense_codes: [],
    customer_code: {
      b2b: '',
      b2c: ''
    },
    mobile_country_code: '',
    mobile_number: '',
    subscription: {
      plan_code: 'sg-corporate-plan',
      duration: 1,
      code: 'sub-2GcUfdBeVDHwKzoCHjs4vDjSaDU',
      source: 'b2b',
      state: SubscriptionStates.enabled,
      start_date: '2022-10-25T08:44:30Z',
      end_date: '2022-11-25T08:44:30Z',
      next_billing_date: '2022-11-25T08:44:30Z',
      last_billing_date: '2022-10-25T08:44:30Z',
      amount: 4.99,
      is_auto_renewal: true
    },
    require_account_linking: true,
    is_eligible_for_all_expense_codes: false,
    account_linked: true,
    pending_orders: 0,
    cancelled_orders: 10,
    delivered_orders: 20,
    in_progress_orders: 1
  },
  {
    id: 5,
    name: 'Frank, Sinatra',
    first_name: 'Frank',
    last_name: 'Sinatra',
    company: 'Apple',
    company_id: 1,
    role: UserRoles.User,
    email: 'frank.sinatra@apple.com',
    state: UserStates.Suspended,
    linked_status: UserLinkStatuses.NotRequired,
    created_at: '2022-04-12T01:42:09Z',
    updated_at: '2022-04-12T01:42:09Z',
    department: {
      id: 100,
      name: 'default',
      total_users: 10
    },
    employee_code: '123',
    cost_center: {
      id: 1,
      name: 'MapleTree Costcentre',
      state: 'Inactive',
      total_users: 23
    },
    expense_codes: [],
    customer_code: {
      b2b: '',
      b2c: ''
    },
    mobile_country_code: '',
    mobile_number: '',
    subscription: null,
    require_account_linking: true,
    is_eligible_for_all_expense_codes: false,
    account_linked: true,
    pending_orders: 0,
    cancelled_orders: 10,
    delivered_orders: 20,
    in_progress_orders: 1
  }
];

export const mockUser: User = mockUserList[0];

// subscribed
export const mockUserListSubscribed = mockUserList.filter(
  (user) => user.subscription !== null
);

export const mockUserWithSubscription: User = {
  ...mockUser,
  subscription: {
    plan_code: 'sg-corporate-plan',
    duration: 1,
    code: 'sub-2GcUfdBeVDHwKzoCHjs4vDjSaDU',
    source: 'b2b',
    state: SubscriptionStates.enabled,
    start_date: '2022-10-25T08:44:30Z',
    end_date: '2022-11-26T08:44:30Z',
    next_billing_date: '2022-11-25T08:44:30Z',
    last_billing_date: '2022-10-25T08:44:30Z',
    amount: 4.99,
    is_auto_renewal: true
  }
};

// unsubscribed
export const mockUserListUnsubcribed = mockUserList.filter(
  (user) => user.subscription === null
);

export const mockUserWithoutSubscription: User = {
  ...mockUser,
  subscription: null
};
